export default __webpack_public_path__ + "static/media/eth.2173a879.svg";